import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const CustomSwitchBox = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
      '&:before': {
        left: 11,
        content: '"לא"',
        color: '#fff',
        fontSize: 13,
        top: 18,
      },
      '&:after': {
        content: '"כן"',
        right: 15,
        color: '#fff',
        fontSize: 13,
        top: '47%',
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#fff'
    },
    '& .MuiSwitch-switchBase:after': {
        content:'"לא"',
        color: 'gray',
        position: 'absolute',
        fontSize: 13,
        top: 10,
        right: 12.5
    },
    '& .MuiSwitch-switchBase.Mui-checked:after': {
        content:'"כן"',
        color: '#b60072',
        right: 14
    },
    '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
        backgroundColor: '#b60072',
        opacity: 1
    }
  }));

  const fieldTypeDic = {
    1: 'checkbox',
    2: 'number',
    3: 'SelectSingle',
    4: 'SelectMultiple',
    5: 'text',
    6: 'ButtonGroup',
    7: 'ButtonSubmit',
    8: 'textarea',
    9: 'tel',
    10: 'email',
    11: 'Date',
    12: 'Time'
}

const getTableRowsReady = (obj) => {

  let finalRows = []
  let contactFilterValues = [""];
  let populationTypeFilterValues = [""];
  let hoursFilterValues = [""];
  let activityTypeFilterValues = [""];
  let participateNumberFilterValues = [""];

  obj?.map(item => {
      let row = {}
      item.GddColumnsData?.map(subItem => {
        if(subItem.GddColumnHeaderID === 1){ row.id = subItem.DisplayData }
        if(subItem.GddColumnHeaderID === 2){ row.projectName = subItem.DisplayData }
        if(subItem.GddColumnHeaderID === 3){ row.associationName = subItem.DisplayData }
        if(subItem.GddColumnHeaderID === 4){ row.creationDate = subItem.DisplayData }
        if(subItem.GddColumnHeaderID === 5){ row.contact = subItem.DisplayData; contactFilterValues.push(subItem.DisplayData) }
        if(subItem.GddColumnHeaderID === 6){ row.populationType = subItem.DisplayData; populationTypeFilterValues.push(subItem.DisplayData) }
        if(subItem.GddColumnHeaderID === 7){ row.hours = subItem.DisplayData; hoursFilterValues.push(subItem.DisplayData) }
        if(subItem.GddColumnHeaderID === 8){ row.activityType = subItem.DisplayData; activityTypeFilterValues.push(subItem.DisplayData) }
        if(subItem.GddColumnHeaderID === 9){ row.participateNumber = subItem.DisplayData; row.participateNumberTitle = subItem.Title; participateNumberFilterValues.push(subItem.DisplayData) }
        if(subItem.GddColumnHeaderID === 10){ row.madeForCompany = subItem.DataIds[0] }
        if(subItem.GddColumnHeaderID === 11){ row.options = subItem.DataIds[0] }
        if(subItem.GddColumnHeaderID === 12){ row.budget = subItem.DisplayData }

      })
      finalRows.push(row)
  })

  contactFilterValues = contactFilterValues.filter((value, index, array) => array.indexOf(value) === index);
  populationTypeFilterValues = populationTypeFilterValues.filter((value, index, array) => array.indexOf(value) === index);
  hoursFilterValues = hoursFilterValues.filter((value, index, array) => array.indexOf(value) === index);
  activityTypeFilterValues = activityTypeFilterValues.filter((value, index, array) => array.indexOf(value) === index);
  participateNumberFilterValues = participateNumberFilterValues.filter((value, index, array) => array.indexOf(value) === index);

  let finalFilters = {
    contact: contactFilterValues,
    populationType: populationTypeFilterValues,
    hours: hoursFilterValues,
    activityType: activityTypeFilterValues,
    participateNumber: participateNumberFilterValues
  }
  return {finalRows: finalRows, finalFilters: finalFilters}
}

const getTableRowsReady2 = (obj, extraData = {}) => {

  let finalRows = []
  let contactFilterValues = [""];
  let populationTypeFilterValues = [""];
  let hoursFilterValues = [""];
  let activityTypeFilterValues = [""];
  let participateNumberFilterValues = [""];

  // Extract translation mappings from extraData
  const populationTranslations = extraData.populationTypes || extraData.projectPopulation || {};
  const activityFieldTranslations = extraData.activityFields || {};

  obj?.map(item => {
      let row = {}
      // Access first contact with primary=true from contacts array, fallback to first contact
      const firstContact = item.contacts && item.contacts.length > 0
        ? (item.contacts.find(c => c.primary === true) || item.contacts[0])
        : null;
      let contact = firstContact?.contact ? `${firstContact.contact.name}\r\n${firstContact.contact.phone}` : '';
      row.id = item._id
      row.projectName = item.name
      row.associationName = item.owner?.name
      row.creationDate = item.createdAt || ''
      row.description = item.description
      row.contact = contact; contactFilterValues.push(contact)
      // Translate population from English key to Hebrew
      const populationKey = item.attributes?.population;
      const populationHebrew = populationKey ? (populationTranslations[populationKey] || populationKey) : "";
      row.populationType = populationHebrew;
      populationTypeFilterValues.push(populationHebrew);

      const shifts = item.shifts;
      const hours = shifts && shifts.length > 0
        ? `${shifts[shifts.length - 1].endTime} - ${shifts[0].startTime}`
        : '';
      row.hours = hours;
      hoursFilterValues.push(hours)

      // Translate activityField from English key to Hebrew
      const activityFieldKey = item.attributes?.activityField || "";
      const activityFieldHebrew = activityFieldKey ? (activityFieldTranslations[activityFieldKey] || activityFieldKey) : "";
      row.activityType = activityFieldHebrew;
      activityTypeFilterValues.push(activityFieldHebrew)
      row.participateNumber = item.attributes?.numVolunteersGuests; participateNumberFilterValues.push(item.attributes?.numVolunteersGuests)
      row.participateNumberTitle = "כותרת הרדקודד טסט"; 
      row.madeForCompany = item.attributes?.suitableForBusiness
      row.options = item.feedback ? true : false
      row.budget = item.budget?.approved

      // Skip cancelled projects
      if (item.status === "cancelled") return;

      finalRows.push(row)

  })

  contactFilterValues = contactFilterValues.filter((value, index, array) => array.indexOf(value) === index);
  populationTypeFilterValues = populationTypeFilterValues.filter((value, index, array) => array.indexOf(value) === index);
  hoursFilterValues = hoursFilterValues.filter((value, index, array) => array.indexOf(value) === index);
  activityTypeFilterValues = activityTypeFilterValues.filter((value, index, array) => array.indexOf(value) === index);
  participateNumberFilterValues = participateNumberFilterValues.filter((value, index, array) => array.indexOf(value) === index);

  let finalFilters = {
    contact: contactFilterValues,
    populationType: populationTypeFilterValues,
    hours: hoursFilterValues,
    activityType: activityTypeFilterValues,
    participateNumber: participateNumberFilterValues
  }
  return {finalRows: finalRows, finalFilters: finalFilters}
}



const extractKeyName = (path) => {
  if(path && path.includes(".")){
      let pathArr = path.split(".")
      return pathArr[pathArr.length - 1]
  }else{
      return path
  }
}

const isJsonString = (str) => {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

const sortArray = (arr) => {
  arr.sort(function(a, b) {
    var keyA = a.Sort,
      keyB = b.Sort
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });
  return arr
}

const stepsDic = {
  ContactSection_form: 0,
  ProjectSection_form: 1,
  PartnerSection_form: 2,
  SuccessFormSection: 3
}

const sendToLoginPage = (locationIdent) => {
  window.location.href = `/${locationIdent}/login`
}

const muiProLicenseKey = "78e2292c9697bad5cf157ede5d239a1cTz0xMjAwMjksRT0xNzkzNDA0Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="

// Transform old form JSON to new API format
const transformOldToNewFormat = (oldJson) => {
  const { Contact, ProjectDetails, ProjectBudgets } = oldJson;

  return {
    project: {
      name: ProjectDetails.Title,
      ownerType: "Municipality",
      address: {
        address: ProjectDetails.Address,
        city: ProjectDetails.CityId || null
      },
      description: ProjectDetails.Description,
      status: "updated",
      assignmentStatus: "noVolunteers",
      budget: {
        details: ProjectBudgets.map(budget => ({
          budgetPurpose: budget.BudgetDescription,
          budgetFromRuachTova: parseFloat(budget.RuachtovaAmount) || 0,
          budgetOfMunicipality: parseFloat(budget.MunicipalityAmount) || 0,
          municipalityResources: budget.MunicipalityValueDescription
        })),
        approved: 0,
        notes: []
      },
      year: new Date().getFullYear(),
      source: "Rashuyot",
      type: ProjectDetails.ProjcetTypeId || "OneTime", // Now stores the English key directly
      notes: ProjectDetails.FormComment ? [{text: ProjectDetails.FormComment, createdAt: new Date()}] : [],
      attributes: {
        timeOfDay: [], // Needs to be mapped from hours
        placeOfVolunteering: ProjectDetails.Location,
        activityField: ProjectDetails.FieldId, // Now stores the English key directly
        projectValues: ProjectDetails.ProjectValues,
        numVolunteersGuests: parseInt(ProjectDetails.VolunteersNum) || 0,
        canPublishOnWebsite: undefined,
        projectOpenToPublic: undefined,
        publicRecruitment: ProjectDetails.IsAllowPublish,
        suitableForBusiness: ProjectDetails.IsForCompany,
        suitableForPR: ProjectDetails.IsForPR,
        hasSecurityClearance: false,
        isMissingInformation: false,
        hasReceivedEquipment: false,
        hasExternalOrganization: ProjectDetails.IsOrganization,
        population: ProjectDetails.Population
      },
      hidden: false
    },
    shift: {
      ...(ProjectDetails.ShiftId && { _id: ProjectDetails.ShiftId }), // Include shift ID only if it exists (edit mode)
      startTime: ProjectDetails.HourFrom ? ProjectDetails.HourFrom.substring(0, 5) : "",
      endTime: ProjectDetails.HourTo ? ProjectDetails.HourTo.substring(0, 5) : ""
    },
    // Return contact as a single object (not array)
    contact: {
      contact: {
        ...(Contact.ContactID && { _id: Contact.ContactID }), // Include contact _id if it exists (edit mode)
        name: `${Contact.FirstName} ${Contact.LastName}`,
        email: Contact.Email,
        phone: Contact.Phone,
      },
      primary: true
    }
  };
};

// Transform new API format back to old form JSON (for edit mode)
const transformNewToOldFormat = (apiResponse) => {
  // Handle both formats: direct project object or wrapped in project/shift/contact
  const project = apiResponse.project || apiResponse;
  const shift = apiResponse.shift || (project.shifts && project.shifts[0]) || {};
  // Access first contact from contacts array
  const contactWrapper = apiResponse.contact || (project.contacts && project.contacts.length > 0 ? project.contacts[0] : {});
  const contact = contactWrapper.contact || contactWrapper;

  // Split contact name
  const nameParts = (contact.name || "").split(" ");
  const firstName = nameParts[0] || "";
  const lastName = nameParts.slice(1).join(" ") || "";

  return {
    ProjectID: project._id || 0,
    Contact: {
      ContactID: contact._id || "",
      LastName: lastName,
      FirstName: firstName,
      Phone: contact.phone || "",
      Position: contactWrapper.role || contact.role || "",
      Email: contact.email || ""
    },
    ProjectDetails: {
      Title: project.name || "",
      ProjcetTypeId: project.type || "OneTime", // Now stores the English key directly
      IsOrganization: project.attributes?.hasExternalOrganization || false,
      OrganizationName: "",
      Location: project.attributes?.placeOfVolunteering || "",
      FieldId: project.attributes?.activityField || "", // Now stores the English key directly
      Description: project.description || "",
      ProjectValues: project.attributes?.projectValues || "",
      Population: project.attributes?.population || "",
      VolunteersNum: String(project.attributes?.numVolunteersGuests || ""),
      IsAllowPublish: project.attributes?.canPublishOnWebsite || false,
      IsForCompany: project.attributes?.suitableForBusiness || false,
      IsForPR: project.attributes?.suitableForPR || false,
      Address: project.address?.address || "",
      CityId: project.address?.city?._id || project.address?.city || "",
      HourFrom: shift.startTime ? `${shift.startTime}:00` : "",
      HourTo: shift.endTime ? `${shift.endTime}:00` : "",
      FormComment: project.notes?.[0]?.text || project.notes?.[0] || "",
      ShiftId: shift._id || "" // Store shift ID for edit mode
    },
    ProjectBudgets: project.budget?.details?.map((budget, index) => ({
      ProjectBudgetID: index + 1,
      BudgetDescription: budget.budgetPurpose || "",
      MunicipalityValueDescription: budget.municipalityResources || "",
      MunicipalityAmount: budget.budgetOfMunicipality !== null && budget.budgetOfMunicipality !== undefined ? String(budget.budgetOfMunicipality) : "",
      RuachtovaAmount: budget.budgetFromRuachTova !== null && budget.budgetFromRuachTova !== undefined ? String(budget.budgetFromRuachTova) : ""
    })) || [],
    ProjectPartners: []
  };
};

export {
  CustomSwitchBox,
  fieldTypeDic,
  getTableRowsReady,
  muiProLicenseKey,
  extractKeyName,
  isJsonString,
  sortArray,
  stepsDic,
  sendToLoginPage,
  getTableRowsReady2,
  transformOldToNewFormat,
  transformNewToOldFormat
}